import { render, staticRenderFns } from "./ConversationPanel.vue?vue&type=template&id=5a706aa4&scoped=true"
import script from "./ConversationPanel.vue?vue&type=script&lang=js"
export * from "./ConversationPanel.vue?vue&type=script&lang=js"
import style0 from "./ConversationPanel.vue?vue&type=style&index=0&id=5a706aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a706aa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VCardText,VTextField})
